import { useQueryClient } from "@tanstack/react-query";

import { meQueryOptions } from "@/features/auth";
import { $api } from "@/shared/api";

import { FRIENDS_QUERY_KEY } from "./FRIENDS_QUERY_KEY";

// Показывать ли себя друзьям (`PATCH /api/me`): ответ — в кэш текущего пользователя,
// таблица друзей перечитывается — скрытому она не показывается.
export const useUpdateFriendsVisible = () => {
  const queryClient = useQueryClient();
  return $api.useMutation("patch", "/api/me", {
    onSuccess: (user) => {
      queryClient.setQueryData(meQueryOptions().queryKey, user);
      void queryClient.invalidateQueries({ queryKey: FRIENDS_QUERY_KEY });
    },
  });
};
